/*
 * premierstreets
 * version 4.5
 * www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
export class VendorModel {
    public companyName: string;
    public companyDescription: string;
    public shortDescription: string;
    public companyLogo: string;
    public companyLogoPath: string;
    public image: string;
    public imagePath: string;
    public vendorPrefixId: string;
    public vendorId: number;
    public shopImage: string;
    public shopImagePath: string;
    public categoryTagline: string;
    public rating: number;
    public wishListStatus: number;
    public wishlistId: number;
    public customerId: number;
    public customer: any;
    public companyCoverImagePath: string;
    public companyCoverImage: string;
    public belongsToEntertainment: boolean;
    public vendorMarketplace: any;
    public subdomain: string;
    constructor(data: any) {
        this.companyName = data.companyName || '';
        this.companyDescription = data.companyDescription || '';
        this.shortDescription = data.companyDescription ? data.companyDescription.replace(/<\/?[^>]+(>|$)/g, "").split(' ').splice(0, 12).join(' ') : '';
        this.image = data.companyCoverImage || '';
        this.imagePath = data.companyCoverImagePath || '';
        this.companyLogo = data.companyLogo || '';
        this.imagePath = data.companyCoverImagePath || '';
        this.companyLogoPath = data.companyLogoPath || '';
        this.vendorPrefixId = data.vendorPrefixId || '';
        this.vendorId = data.vendorId || '';
        this.shopImage = data.shopImage || '';
        this.shopImagePath = data.shopImagePath || '';
        this.categoryTagline = data.categories.length > 0 ? data.categories.map(item => item.name).join(', ') : ""
        this.rating = data.rating ? data.rating : 0;
        this.wishListStatus = data.wishListStatus;
        this.wishlistId = data.wishlistId;
        this.customerId = data.customerId;
        this.customer = data.customer;
        this.companyCoverImage = data.companyCoverImage || '';
        this.companyCoverImagePath = data.companyCoverImagePath || '';
        this.belongsToEntertainment = data.belongsToEntertainment || false;
        this.vendorMarketplace = data.vendorMarketplace || [];
        this.subdomain = data.subdomain || '';
    }
}
